import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

import { BaseFormInput } from '../base-form-input';

@Component({
    selector: 'nuso-select-input',
    templateUrl: './select-input.component.html',
    styleUrls: ['./select-input.component.css'],
    standalone: false
})
export class SelectInputComponent extends BaseFormInput {
}
